import { useRouteLoaderData } from 'react-router';
import type { InitialData } from '~/lib/getInitialData';
import { useRootDataFromProvider } from '~/providers/RootDataProvider';
import type { loader } from '~/root';

export default function useRootData(): InitialData {
  // Try to get data from the provider context first
  const serverData = useRouteLoaderData<typeof loader>('root')!;

  const providerData = useRootDataFromProvider();

  return providerData || serverData;
  // // Fall back to React Router loader data if provider data is not available
  // const routerData: InitialData = useRouteLoaderData<typeof loader>('root')!;

  // // Return provider data if available, otherwise use router data
  // return providerData || routerData;
}
